<template>
<!-- 询价单管理 -->
    <div class="receipt-list-view">
        <Row type="flex">
            <div class="flex-child">
                <span class="input-label">询价单名称</span>
                <span>
                    <Input placeholder=""
                            v-model="search.name"/>
                </span>
            </div>
            <div class="flex-child">
                <span class="input-label">询价单号</span>
                <span>
                    <Input placeholder=""
                            v-model="search.orderNo"/>
                </span>
            </div>
            <div class="flex-child">
                <span class="input-label">选择部门</span>
                <span class="Cascader">
                    <Cascader :data="departmentData"
                        v-model="department"
                        @on-change="getCascader"
                        change-on-select></Cascader>
                </span>
            </div>
            <div class="flex-child">
                <span class="input-label">选择供应商</span>
                <span>
                    <Select v-model="search.supplierNo" filterable clearable style="width: 300px">
                        <Option v-for="(item, index) in supplierList" :value="item.supplierNo" :key="index">{{ item.supplierName }}</Option>
                    </Select>
                </span>
            </div>
            <div class="flex-child">
                <span class="input-label">状态</span>
                <span>
                    <Select v-model="search.state" style="width: 140px">
                        <Option v-for="(item, index) in stateList" :value="item.value" :key="index">{{ item.label }}</Option>
                    </Select>
                </span>
            </div>
            <!-- <div class="flex-child">
                <span class="input-label">生效时间</span>
                <DatePicker
                    type="date"
                    style="width: 160px"
                    placeholder="选择日期"
                    format="yyyy-MM-dd"
                    :options="options1"
                    v-model="search.startTime"
                    @on-change="getFormatStartDate">
                </DatePicker>
            </div>
            <div class="flex-child">
                <span class="input-label">结束时间</span>
                <DatePicker
                    type="date"
                    style="width: 160px"
                    placeholder="选择日期"
                    format="yyyy-MM-dd"
                    :options="options2"
                    v-model="search.endTime"
                    @on-change="getFormatEndDate"></DatePicker>
            </div> -->
            <div class="flex-child">
                <Button type="primary" @click="lookSearch">查询</Button>
                <Button
                    style="margin-left: 16px"
                    @click="handleReset">
                    重置
                </Button>
            </div>
        </Row>
        <Row type="flex" v-if="cuSupplier === 'admin1003' || cuSupplier === 'sadmin'">
            <div class="flex-child">
                <Button>
                    <span @click="creatTemplate">模板创建</span>
                </Button>
                <Button>
                    <span @click="exportIn">导入询价单</span>
                </Button>
            </div>
        </Row>
        <Table :columns="colHidden"
            :data="list"
            :height="520"
        >
            <template slot-scope="{ row }" slot="quotationNo">
                <span class="is-router-link" @click="handleClick(4, row)">{{ row.quotationNo }}</span>
            </template>
            <!-- <template slot-scope="{ row }" slot="sync">
                <span v-if="row.sync === 1" style="color: #00cc66">已同步</span>
                <span v-if="row.sync === 2">未同步</span>
            </template> -->
            <template slot-scope="{ row }" slot="state">
                <span v-if="row.state === 3">未发布</span>
                <span v-if="row.state === 1" style="color: #00cc66">已发布</span>
                <span v-if="row.state === 2" style="color: #ff9900">已作废</span>
            </template>
            <template slot-scope="{ row }" slot="action">
                <!-- 发布后不可修改 -->
                <div class="btn-action">
                    <Button
                        v-if="row.state === 3"
                        size="small"
                        type="primary"
                        @click="handleClick(1, row)"
                    >发布</Button>
                    <Button
                        v-if="row.state === 3"
                        size="small"
                        @click="handleClick(2, row)"
                    >修改</Button>
                    <!-- <Button
                        v-if="row.state === 1 && row.sync === 2"
                        size="small"
                        type="primary"
                        @click="handleClick(10, row)"
                    >同步</Button> -->
                    <Button
                        v-if="row.state === 1"
                        size="small"
                        @click="handleClick(3, row)"
                    >作废</Button>
                    <span v-if="row.state === 2 && row.sync === 1">--</span>
                </div>
            </template>
        </Table>
        <div class="pages-box">
            <Page
                :current="search.currentPage"
                :total="totalItems"
                show-sizer
                :page-size="search.pageSize"
                @on-change="getChangePageNum"
                @on-page-size-change="getChangePageSize"/>
        </div>
        <Modal
            v-model="modal"
            class="export-template-modal"
            :mask-closable="false"
            :title="modalTitle">
            <Form ref="form" :model="form" :rules="rule" :label-width="90">
                <Form-item label="询价单名称" prop="name">
                    <Input placeholder=""
                            class="item-w"
                            v-model="form.name"/>
                 </Form-item>
                <Form-item label="选择供应商" prop="supplierNo">
                    <Select v-model="form.supplierNo" filterable clearable class="item-w">
                        <Option v-for="(item, index) in supplierList"
                            :value="item.supplierNo"
                            :key="index"
                            :label="item.supplierName"
                        >
                            <span>{{ item.supplierName }}</span>
                            <span style="float: right">{{ item.supplierNo }}</span>
                        </Option>
                    </Select>
                </Form-item>
                <Form-item label="选择食堂" prop="interest">
                    <el-cascader
                        class="item-w"
                        v-model="form.canteen"
                        :options="departmentData"
                        :props="props"
                        collapse-tags
                        clearable></el-cascader>
                </Form-item>
                <Form-item label="导入询价单" prop="order">
                    <span class="import-model-span">
                        <Button type="primary">导入询价单</Button>
                        <input type="file" name="files" class="import-input" @change="exportInOrder">
                    </span>
                    <Table :columns="columns2"
                        :data="exportOrderList"
                        :height="260"
                        class="table-padding-0"
                    >
                    </Table>
                </Form-item>
                <Form-item label="生效时间" prop="startTime">
                    <DatePicker
                        type="date"
                        placeholder="选择日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        :options="options3"
                        v-model="form.startTime"
                        @on-change="getStartDate">
                    </DatePicker>
                </Form-item>
                <Form-item label="结束时间" prop="endTime">
                    <DatePicker
                        type="date"
                        placeholder="选择日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        :options="options4"
                        v-model="form.endTime"
                        @on-change="getEndDate">
                    </DatePicker>
                </Form-item>
            </Form>
            <template slot="footer">
                <Button @click="modal = false">取消</Button>
                <Button type="primary" @click="submitExport" :loading="submitLoading">确定</Button>
            </template>
        </Modal>
        <Modal
            v-model="tipModal"
            :mask-closable="false"
            :title="tipModalTitle">
            <p>{{tipModalCon}}</p>
            <template slot="footer">
                <Button @click="tipModal = false">取消</Button>
                <Button type="primary" @click="submitTip" :loading="submitTipLoading">确定</Button>
            </template>
        </Modal>
        <Modal
            v-model="errorModal"
            class="error-modal"
            :mask-closable="false"
            title="错误提示">
            <p style="white-space: pre-line" class="error-modal-p">{{ errorModalCon }}</p>
            <template slot="footer">
                <Button type="primary" @click="errorModal = false">确定</Button>
            </template>
        </Modal>
    </div>
</template>

<script>
import axios from 'axios';
import {
    selectAllQuotationInfo,
    adminGetSupplierList,
    publishQuotation,
    repealQuotation,
    syncQuotation,
    getQuotationByQuotationNo
} from '@/graphql/graphql.js';
import { postUrl2 } from '@/graphql/url.js';
import { formatTime } from '@/utils/date.js';
import { clone } from '@/assets/js/clone.js';
import Moment from 'moment';
import Cookies from 'js-cookie';
import XLSX from 'xlsx';

export default {
    beforeRouteEnter(to, from, next) {
        if (from.path !== '/index/materials-price/detail') {
            window.sessionStorage.removeItem('materPriceSearch');
        }
        next();
    },
    data() {
        const self = this;
        return {
            supplierList: [],
            departmentData: [],
            department: [],
            timeOut: null,
            search: {
                name: '',
                orderNo: '',
                supplierNo: '',
                startTime: '',
                state: '10',
                departm: '',
                endTime: '',
                pageSize: 20,
                currentPage: 1
            },
            stateList: [
                {
                    label: '全部',
                    value: '10'
                },
                {
                    label: '已发布',
                    value: '1'
                },
                {
                    label: '未发布',
                    value: '3'
                },
                {
                    label: '作废',
                    value: '2'
                }
            ],
            totalItems: 0,
            list: [],
            colHidden: [],
            columns: [
                {
                    title: '询价单',
                    slot: 'quotationNo',
                    align: 'left',
                    minWidth: 150
                },
                {
                    title: '供应商编码',
                    key: 'supplierNo',
                    align: 'left',
                    minWidth: 120
                },
                {
                    title: '供应商名称',
                    key: 'supplierName',
                    align: 'left',
                    minWidth: 180
                },
                {
                    title: '状态',
                    slot: 'state',
                    align: 'left',
                    width: 100
                },
                // {
                //     title: '是否同步',
                //     slot: 'sync',
                //     align: 'left',
                //     width: 100
                // },
                {
                    title: '创建时间',
                    key: 'createdAt',
                    align: 'left',
                    minWidth: 150
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    fixed: 'right',
                    width: 180
                }
            ],
            pageInfo: {
                classify: []
            },
            type: 0,
            modal: false,
            modalTitle: '',
            submitLoading: false,
            form: {
                name: '',
                supplierNo: '',
                canteen: [],
                endTime: '',
                startTime: ''
            },
            rule: {},
            columns2: [
                {
                    title: '序号',
                    key: 'serialCount',
                    minWidth: 60
                },
                {
                    title: '物资编码',
                    key: 'productNo',
                    width: 100
                },
                {
                    title: '物资名称',
                    key: 'productName',
                    minWidth: 100
                },
                {
                    title: '物资规格',
                    key: 'productSpectype',
                    minWidth: 100
                },
                {
                    title: '物资描述',
                    key: 'productSpec',
                    minWidth: 80
                },
                {
                    title: '单价',
                    key: 'price',
                    width: 100
                }
            ],
            rowInfo: {},
            rowId: null,
            props: { multiple: true },
            orderName: '',
            exportOrderList: [],
            tipModal: false,
            tipModalTitle: '',
            tipModalCon: '',
            submitTipLoading: false,
            cuSupplier: '',
            fileBuffer: {},
            selectedFile: null,
            options1: {
                disabledDate(date) {
                    return (date && date.valueOf() >
                    new Date(new Date(self.search.endTime).getFullYear(),
                        new Date(self.search.endTime).getMonth(), new Date(self.search.endTime).getDate()).valueOf());
                }
            },
            options2: {
                disabledDate(date) {
                    return date && date.valueOf() < self.getTimeBegin();
                }
            },
            options3: {
                disabledDate(date) {
                    return (date && date.valueOf() >
                    new Date(new Date(self.form.endTime).getFullYear(),
                        new Date(self.form.endTime).getMonth(), new Date(self.form.endTime).getDate()).valueOf());
                }
            },
            options4: {
                disabledDate(date) {
                    return date && date.valueOf() < self.getTimeBegin1();
                }
            },
            errorModal: false,
            errorModalCon: ''
        };
    },
    created() {
        this.cuSupplier = Cookies.getJSON('supplierNo');
        if (this.cuSupplier === 'admin1003' || this.cuSupplier === 'sadmin') {
            this.colHidden = this.columns;
        } else {
            const arr = clone(this.columns);
            arr.splice(-1, 1);
            this.colHidden = arr;
        }
    },
    mounted() {
        let queryVars = {
            currentPage: 1,
            pageSize: 500
        };
        let len = 0;
        this.getSupplierList(queryVars, len);
        const searchFilter = JSON.parse(window.sessionStorage.getItem('materPriceSearch'));
        if (searchFilter) {
            this.search = searchFilter;
        } else {
            const lastDay = Moment().endOf('month').toDate();
            this.search.endTime = formatTime(lastDay);
        }
        this.getAllOrganList();
        this.getPriceList();
    },
    methods: {
        creatTemplate() {
            this.$router.push({
                path: '/index/materials-price/create'
            });
        },

        handleClick(type, row) {
            this.type = type;
            this.rowId = row.id;
            switch (type) {
                case 1:
                    this.tipModalTitle = '发布';
                    this.tipModalCon = `确定发布询价单${row.quotationNo}?`;
                    this.tipModal = true;
                    break;
                case 2:
                    this.getAllOrganList();
                    this.modalTitle = '修改询价单';
                    this.getDetail(row.quotationNo);
                    this.modal = true;
                    break;
                case 3:
                    this.tipModalTitle = '作废';
                    this.tipModalCon = `确定作废询价单${row.quotationNo}?`;
                    this.tipModal = true;
                    break;
                case 4:
                    const obj = this.search;
                    window.sessionStorage.setItem('materPriceSearch', JSON.stringify(obj));
                    this.$router.push({
                        path: '/index/materials-price/detail',
                        query: {
                            quotationNo: row.quotationNo
                        }
                    });
                    break;
                case 10:
                    this.tipModalTitle = '同步';
                    this.tipModalCon = `确定同步询价单${row.quotationNo}?`;
                    this.tipModal = true;
                    break;
            }
        },
        // 导入
        exportIn() {
            this.getAllOrganList();
            this.modalTitle = '导入询价单';
            this.type = 0;
            const form = this.form;
            form.name = '';
            form.supplierNo = '';
            form.canteen = [];
            this.exportOrderList = [];
            this.selectedFile = null;
            const lastDay = Moment().endOf('month').toDate();
            form.startTime = '';
            form.endTime = formatTime(lastDay);
            this.modal = true;
        },
        exportInOrder(ev) {
            let file = ev.target.files[0];
            const _self = this;
            if (!file) {
                _self.$setNotice('询价单上传失败');
                return;
            }
            let reader = new FileReader();
            reader.onload = function(e) {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                // const headers = jsonData.shift();
                const filteredData = jsonData.filter((row) => row.join(''));
                _self.process_wb(filteredData, sheetName);
            };
            reader.readAsArrayBuffer(file);
            ev.target.value = '';
        },
        process_wb(modelArr, sheetName) {
            if (!modelArr || (modelArr.length && modelArr[0][6] !== '单价（元）')) {
                this.$setNotice('请上传正确的询价单');
                return;
            }
            let tableHead = modelArr.splice(0, 1);
            let goNext = true;
            let temporaryArr = [];
            modelArr.forEach((ele, key) => {
                if (ele.length >= 6) {
                    if (ele[6] && Number(ele[6]) > 0) {
                        if (ele[0] && ele[1]) {
                            temporaryArr.push({
                                serialCount: Number(key + 1),
                                productNo: ele[1].toString(),
                                productName: ele[0],
                                productSpec: ele[5],
                                productSpectype: ele[4],
                                price: Number(ele[6]).toFixed(2)
                            });
                        }
                    } else {
                        goNext = false;
                    }
                } else {
                    modelArr.splice(key, 1);
                }
            });
            if (goNext) {
                const duplicates = this.findDuplicateIdsWithIndices(temporaryArr);
                if (duplicates.length) {
                    const dup = duplicates[0];
                    const du = dup.indices;
                    this.$Notice.open({
                        title: '物资重复',
                        desc: `询价单第${du[1] + 2}和第${du[2] + 2}行物资可能重复了，请核对`,
                        duration: 20
                    });
                } else {
                    this.exportOrderList = temporaryArr;
                    const newWorksheet = XLSX.utils.json_to_sheet(modelArr);
                    const newWorkbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(newWorkbook, newWorksheet, sheetName);
                    const blob = XLSX.write(newWorkbook, { bookType: 'xlsx', type: 'array' });
                    this.selectedFile = blob;
                }
            } else {
                this.$Notice.open({
                    title: '询价单有误',
                    desc: '单价不能为空且大于0',
                    duration: 10
                });
            }
        },
        findDuplicateIdsWithIndices(array) {
            const ids = {};
            const duplicateIds = [];
            array.forEach((item, index) => {
                if (ids[item.productNo]) {
                    duplicateIds.push(item.productNo);
                } else {
                    ids[item.productNo] = [index];
                }
                ids[item.productNo].push(index);
            });
            return duplicateIds.map(productNo => ({ productNo, indices: ids[productNo].sort((a, b) => a - b) }));
        },
        to_json(workbook) {
            let result = {};
            workbook.SheetNames.forEach(sheetName => {
                var roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
                    header: 1
                });
                if (roa.length) result[sheetName] = roa;
            });
            return JSON.stringify(result, 2, 2);
        },
        submitExport() {
            const form = this.form;
            const startTimeStr = typeof form.startTime === 'object' ? formatTime(form.startTime) : form.startTime;
            const endTimeStr = typeof form.endTime === 'object' ? formatTime(form.endTime) : form.endTime;
            if (!form.supplierNo) {
                this.$setNotice('请选择供应商');
                return;
            }
            if (!form.canteen.length) {
                this.$setNotice('请选择食堂');
                return;
            }
            if (!this.exportOrderList) {
                this.$setNotice('请导入询价单');
                return;
            }
            if (!startTimeStr) {
                this.$setNotice('请选择生效时间');
                return;
            }
            if (!endTimeStr) {
                this.$setNotice('请选择结束时间');
                return;
            }
            let canteen = [];
            form.canteen.forEach(item => {
                canteen.push(item[item.length - 1]);
            });
            const formData = new FormData();
            formData.append('supplierNo', Cookies.getJSON('USER-INFO').supplierNo);
            formData.append('quotationInfo', JSON.stringify({
                name: form.name,
                supplierNo: form.supplierNo,
                cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                organ: canteen.join(','),
                startTime: startTimeStr,
                endTime: endTimeStr
            }));
            if (this.selectedFile !== null) {
                formData.append('file', new Blob([this.selectedFile], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
            }
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            if (this.type === 0) {
                this.submitLoading = true;
                axios.post(postUrl2 + '/supplier/quotation/importQuotation', formData, config).then(res => {
                    const data = res.data;
                    this.submitLoading = false;
                    if (data && data.code === 200) {
                        this.$setNotice('导入成功');
                        this.modal = false;
                        this.search.currentPage = 1;
                        this.getPriceList();
                    } else {
                        this.errorModalCon = data.message.replace(/,/g, ',\n');
                        this.errorModal = true;
                    }
                }).catch(error => {
                    this.submitLoading = false;
                    this.$Message.error(error.message);
                });
            } else if (this.type === 2) {
                this.submitLoading = true;
                formData.append('id', this.rowId);
                axios.post(postUrl2 + '/supplier/quotation/updateQuotation', formData, config).then(res => {
                    const data = res.data;
                    this.submitLoading = false;
                    if (data && data.code === 200) {
                        this.$setNotice('修改成功');
                        this.modal = false;
                        this.search.currentPage = 1;
                        this.getPriceList();
                    } else {
                        this.$Message.error(data.message);
                    }
                }).catch(error => {
                    this.submitLoading = false;
                    this.$Message.error(error.message);
                });
            }
        },
        submitTip() {
            if (this.type === 1) {
                // 发布
                this.submitTipLoading = true;
                this.$apollo.mutate({
                    mutation: publishQuotation,
                    context: { useApi1: false },
                    variables: {
                        id: this.rowId
                    }
                }).then(res => {
                    const data = res.data.publishQuotation;
                    this.submitTipLoading = false;
                    if (data && data.code === 200) {
                        this.$setNotice('发布成功');
                        this.tipModal = false;
                        this.getPriceList();
                    } else {
                        this.$Message.error(data.message);
                    }
                }).catch(() => {
                    this.submitTipLoading = false;
                });
            } else if (this.type === 3) {
                this.submitTipLoading = true;
                this.$apollo.mutate({
                    mutation: repealQuotation,
                    context: { useApi1: false },
                    variables: {
                        id: this.rowId
                    }
                }).then(res => {
                    const data = res.data.repealQuotation;
                    this.submitTipLoading = false;
                    if (data && data.code === 200) {
                        this.$setNotice('作废成功');
                        this.getPriceList();
                        this.tipModal = false;
                    } else {
                        this.$Message.error(data.message);
                    }
                }).catch(() => {
                    this.submitTipLoading = false;
                });
            } else if (this.type === 10) {
                this.submitTipLoading = true;
                this.$apollo.mutate({
                    mutation: syncQuotation,
                    context: { useApi1: false },
                    variables: {
                        id: this.rowId
                    }
                }).then(res => {
                    const data = res.data.syncQuotation;
                    this.submitTipLoading = false;
                    if (data && data.code === 200) {
                        this.$setNotice('同步成功');
                        this.getPriceList();
                        this.tipModal = false;
                    } else {
                        this.$Message.error(data.message);
                    }
                }).catch(() => {
                    this.submitTipLoading = false;
                });
            }
        },
        getPriceList() {
            const params = {
                name: this.search.name,
                quotationNo: this.search.orderNo,
                supplierNo: this.search.supplierNo || Cookies.getJSON('USER-INFO').supplierNo,
                pageNumber: this.search.currentPage,
                pageSize: this.search.pageSize,
                organ: this.search.departm,
                state: Number(this.search.state)
            };
            if (this.search.state === '10') {
                delete params.state;
            }
            this.$apollo.query({
                query: selectAllQuotationInfo,
                context: { useApi1: false },
                variables: {
                    condi: params,
                    cliqueNo: Cookies.getJSON('cliqueNo').toString()
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.selectAllQuotationInfo;
                if (data && data.code === 200) {
                    this.list = data.data;
                    this.totalItems = data.pager.totalItems;
                } else {
                    this.$setNotice(data.message);
                }
            });
        },
        lookSearch() {
            this.search.currentPage = 1;
            this.getPriceList();
        },
        handleReset() {
            this.search.name = '';
            this.search.orderNo = '';
            this.getPriceList();
        },
        getChangePageNum(val) {
            this.search.currentPage = val;
            this.getPriceList();
        },
        getChangePageSize(val) {
            this.search.pageSize = val;
            this.getPriceList();
        },
        async getAllOrganList() {
            if (this.$store.state.organs.length) {
                this.departmentData = this.$store.state.organs;
                clearTimeout(this.timeOut);
            } else {
                clearTimeout(this.timeOut);
                this.timeOut = setTimeout(() => {
                    this.getAllOrganList();
                }, 3000);
            }
        },
        getCascader(val) {
            this.search.departm = val[val.length - 1] || '';
        },
        getSupplierList(qur, len) {
            this.$apollo.query({
                query: adminGetSupplierList,
                context: { useApi1: false },
                variables: {
                    condi: {
                        pageNumber: qur.currentPage,
                        pageSize: qur.pageSize
                    }
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.adminGetSupplierList;
                if (data && data.code === 200) {
                    this.supplierList = this.supplierList.concat(data.data);
                    let len1 = Math.ceil(data.total / 500);
                    if (qur.currentPage < len1) {
                        qur.currentPage += 1;
                        this.getSupplierList(qur, len1);
                    }
                }
            });
        },
        getDetail(id) {
            this.$apollo.query({
                query: getQuotationByQuotationNo,
                context: { useApi1: false },
                variables: {
                    quotationNo: id
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.getQuotationByQuotationNo;
                if (data && data.code === 200) {
                    this.rowInfo = data.data;
                    const res = data.data;
                    this.form.name = res.name;
                    this.form.supplierNo = res.supplierNo;
                    this.form.startTime = res.startTime;
                    this.form.endTime = res.endTime;
                    let organ = res.organNo.split(',');
                    let value = this.findAncestorsById(this.departmentData, organ);
                    this.form.canteen = value;
                    this.exportOrderList = res.quotationItems;
                } else {
                    this.$setNotice('详情获取失败,请重新选择');
                }
            });
        },
        findAncestorsById(tree, leafIds, result = []) {
            const find = (classifyList, id) => {
                let temp = [id];
                let forFn = function(arr, id) {
                    for (let i = 0;i < arr.length;i++) {
                        let item = arr[i];
                        if (item.children) {
                            let data1 = item.children.find((item1) => item1.value === id);
                            if (data1) {
                                temp.unshift(item.value);
                                forFn(classifyList, item.value);
                                break;
                            } else {
                                forFn(item.children, id);
                            }
                        }
                    }
                };
                forFn(classifyList, id);
                return temp;
            };
            leafIds.forEach((str) => {
                result.push(find(tree, str));
            });
            return result;
        },
        // 获取格式化日期 && 开始日期
        getFormatStartDate(date) {
            this.search.startTime = date;
            if (typeof this.search.endTime !== 'string') {
                this.search.endTime = formatTime(this.search.endTime);
            }
        },
        // 结束日期
        getFormatEndDate(date) {
            this.search.endTime = date;
        },
        getStartDate(date) {
            this.form.startTime = date;
            if (typeof this.form.endTime !== 'string') {
                this.form.endTime = formatTime(this.form.endTime);
            }
        },
        // 结束日期
        getEndDate(date) {
            this.form.endTime = date;
        },
        getTimeBegin() {
            return Date.parse(this.search.startTime);
        },
        getTimeBegin1() {
            return Date.parse(this.form.startTime);
        }
    }
};
</script>

<style scoped lang="stylus">
@import '../../assets/stylus/views/receipt-list.styl'
.pages-box button {
    width: 200px;
    height: 40px;
    font-size: 14px;
}
.flex-left {
    margin-left: 20px;
}
.item-w
    width: 65%;
.table-padding-0
    margin-top: 10px;
.btn-action
    button+button
        margin-left: 4px;
.error-modal-p
    font-size: 14px;
    color: #515a6e;
.import-model-span
    position: relative;

    .import-input
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        color: transparent;
        border: 1px solid #dcdee2;
        border-radius: 4px;
        z-index: 5;
        text-indent: 999999999px;
        cursor: pointer;
        outline: none;

    button
        position: relative;
        z-index: 3;
        border: none;
</style>



// WEBPACK FOOTER //
// src/views/materialsPrice/index.vue